import { GPS_STREAM_CHECKS } from '../checks'
import type { Finding } from '../finding'
import type { GpsFixReading } from '../gpsFix'
import { UNCHECKED_TRUST, type GpsStreamTrust } from './gpsStreamTrust'

export function runGpsStreamChecks(fixes: readonly GpsFixReading[]): {
  trust: GpsStreamTrust
  findings: Finding[]
} {
  let trust = UNCHECKED_TRUST
  const findings: Finding[] = []
  for (const check of GPS_STREAM_CHECKS) {
    const verdict = check.run(fixes, trust)
    trust = verdict.trust
    if (verdict.finding) findings.push(verdict.finding)
  }
  return { trust, findings }
}
